import React from 'react';
import { historyService, history } from '../../../../services/history';

import Tabs from '../../../../common/components/tabs';
import Tab from '../../../../common/components/tab';
import BreadCrumbs from './breadcrumbs';
import { T } from '../../../../../../common/locale/translate';

export default class OfferTypeTabs extends React.Component {
  constructor() {
    super();
    this.state = {
      activeIndex: 0,
      activeValue: 'A',
      unlisten: () => {},
      types: { A: 0, S: 1, C: 2, C1: 2, C2: 2, GROUP: 3 },
      offer_types: {
        C1: { genre: 'flight', name: T('flight_tickets') },
        C2: { genre: 'flight', name: T('flight_tickets') },
        S: { genre: 'withHotel', name: T('only_hotels') },
        A: { genre: 'withHotel', name: T('holiday') },
        NoData: { genre: 'NoData', name: T('no_offers') },
        Error: { genre: 'Error', name: T('system_error') }
      },
      icons: {
        A: '/img/icons/search/tours.svg',
        S: '/img/icons/search/hotels.svg',
        C: '/img/icons/search/plane_tickets.svg',
        C1: '/img/icons/search/plane_tickets.svg',
        C2: '/img/icons/search/plane_tickets.svg',
        GROUP: '/img/icons/search/group_reservations.svg'
      },
      params: {}
    };

    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleHistoryChange = this.handleHistoryChange.bind(this);
  }

  componentDidMount() {
    const params = this.props.params;
    if (typeof history() == 'undefined') {
      historyService.createComponentHistory();
    }
    const unlisten = historyService.listener(this.handleHistoryChange);
    if (params['offer_type']) {
      this.setState({
        activeIndex: this.state.types[params['offer_type']],
        activeValue: params['offer_type'],
        unlisten,
        params
      });
    }
  }

  componentWillUnmount() {
    this.state.unlisten();
  }

  render = () => {
    const { breadcrumbs, seo_params, handleTabChange } = this.props;
    const { activeValue, activeIndex, icons, params } = this.state;
    return (
      <div>
        <div className="tabs wrapper">
          <Tabs
            activeIndex={activeIndex}
            handleTabChange={(value, index) => {
              if (handleTabChange) {
                handleTabChange(value, index);
                this.setState({ activeIndex: index, activeValue: value });
              } else {
                this.handleTabChange(value, index);
              }
            }}
            offerType={activeValue}
            class_name="mobile-tabs"
          >
            <Tab name={T('holiday')} type="tours" value="A" icon={icons['A']} />
            <Tab
              name={T('only_hotels')}
              type="hotels"
              value="S"
              icon={icons['S']}
            />
            <Tab
              name={T('flight_tickets')}
              type="plane-tickets"
              value="C2"
              icon={icons['C2']}
            />
            <Tab
              name={T('group_reservations')}
              mobile_name={T('group_reservations_short')}
              type="group-reservations"
              value="GROUP"
              icon={icons['GROUP']}
            />
          </Tabs>
        </div>
        <BreadCrumbs
          breadcrumbs={breadcrumbs}
          seo_params={seo_params}
          params={params}
          offer_type={activeValue}
        />
      </div>
    );
  };

  handleTabChange(value, index) {
    let params = historyService.params();
    params =
      typeof params['offer_type'] == 'undefined' ? this.props.params : params;
    this.setState({ activeIndex: index, activeValue: value });
    if (value !== params['offer_type']) {
      params['offer_type'] = value;
      history().push({
        pathname: '/offers',
        search: `?${historyService.parseObject2Params(params)}`
      });
    }
  }

  handleHistoryChange(_, params) {
    params = params['offer_type'] ? params : this.props.params;
    if (
      params['offer_type'] &&
      this.state.activeValue !== params['offer_type']
    ) {
      this.setState({
        activeIndex: this.state.types[params['offer_type']],
        activeValue: params['offer_type'],
        seo_title: false,
        params
      });
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/tabs/index.js